import { getAds } from '@/graphql/queries/media/article';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getAds).then(ads => {
    const description = store.$i18n.t('ads.description');
    const subtitle = store.$i18n.t('ads.jumbotron.subtitle');
    const title = store.$i18n.t('ads.title');
    store.commit('adverts/setRadioAds', ads.filter(ad => ad.audio));
    store.commit('adverts/setVideoAds', ads.filter(ad => ad.video));
    store.commit('pageContent/setHead', { description, title });
    store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-blog-newsletter-signup', subtitle, title, type: 'generic' });
  });
};
